export class CookieBox {

    constructor() {
    }

    private DOMElements: any = {
        cookieBox: null,
        closeButton: null,
        closeButton2: null,
    }

    private cookieName: string = 'cookie-box-closed'
    private gtagCookieName: string = 'gtag-enabled'

    init() {
        this.DOMElements.cookieBox = document.querySelector('.cookie-box');

        if (document.getElementsByTagName('body')[0].classList.contains('neos-backend')) {
            this.showBox();
            return;
        }

        if (!this.DOMElements.cookieBox) {
            return;
        }

        this.DOMElements.closeButton = this.DOMElements.cookieBox.querySelector('.cookie-box__close');
        this.DOMElements.closeButton2 = this.DOMElements.cookieBox.querySelector('.cookie-box__close2');

        this.handleCookieBox();
        this.checkGtag();
    }

    handleCookieBox() {
        const hasCookie = this.isCookieSet();

        if (hasCookie) {
            this.removeBox();
        } else {
            this.showBox();

            this.DOMElements.closeButton.addEventListener('click', () => {
                this.setCookie();
                this.removeBox();
            });

            this.DOMElements.closeButton2.addEventListener('click', () => {
                this.setCookie();
                this.setGtagCookie();
                this.removeBox();
                this.loadGtag();
            });
        }
    }

    checkGtag() {
        if (this.isGtagCookieSet()) {
            this.loadGtag();
        }
    }

    loadGtagOld() {
        const gtagScript = document.createElement('script');
                           gtagScript.async = true;
                           gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-RJ4XTJEEER';
                           document.head.appendChild(gtagScript);

                               const gtagInitScript = document.createElement('script');
                               gtagInitScript.innerHTML = `
                                   window.dataLayer = window.dataLayer || [];
                                   function gtag(){dataLayer.push(arguments);}
                                   gtag('js', new Date());
                                   gtag('config', 'G-RJ4XTJEEER');
                                   gtag('config', 'AW-1033019268');
                               `;

                               document.head.appendChild(gtagInitScript);
                           }

    loadGtag() {
        window.dataLayer = window.dataLayer || [];
        function gtag(a,b,c){window.dataLayer.push(arguments);}
        gtag('consent', 'update', {
            'ad_storage': 'granted',
            'ad_user_data': 'granted',
            'ad_personalization': 'granted',
            'analytics_storage': 'granted'
        });
    }
    showBox() {
        const parent = this.DOMElements.cookieBox.parentNode;
        parent.parentElement.insertBefore(this.DOMElements.cookieBox, parent);
        this.DOMElements.cookieBox.classList.remove('invisible');
    }

    removeBox() {
        this.DOMElements.cookieBox.parentElement.removeChild(this.DOMElements.cookieBox);
    }

    getCookie(cookieName: string): string {
        const cookie = document.cookie.split('; ').find(row => row.startsWith(cookieName));
        if (!cookie) {
            return '';
        }
        const cookieSplit = cookie.split('=');
        return cookieSplit[1] || '';
    }

    isCookieSet() {
        return this.getCookie(this.cookieName) === '1';
    }

    setCookie() {
        var now = new Date();
        var time = now.getTime();
        time += 3600 * 1000 * 24; //24h
        now.setTime(time);
        document.cookie = this.cookieName + "=1; expires=" + now.toUTCString() + "; SameSite=None; Secure";
    }

    clearCookie() {
        document.cookie = this.cookieName + "=0; expires=Fri, 31 Dec 1970 23:59:59 GMT; SameSite=None; Secure";
    }

    isGtagCookieSet() {
        return this.getCookie(this.gtagCookieName) === '1';
    }

    setGtagCookie() {
        document.cookie =this.gtagCookieName + "=1; SameSite=None; Secure";
    }
    clearGtagCookie() {
        document.cookie = this.gtagCookieName + "=0; expires=Fri, 31 Dec 1970 23:59:59 GMT; SameSite=None; Secure";
    }
}

declare global {
    interface Window {
        dataLayer:any;
    }
}
